































import { defineComponent, ref, onMounted } from "@nuxtjs/composition-api";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import { usePageStore } from "~/stores/page";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import { useUiHelpers, useSearchProducts } from "~/composables";
SwiperCore.use([Navigation, Pagination, Scrollbar]);

export default defineComponent({
  name: "RecentlyViewedProducts",
  components: {
    CategoryProductCard,
    ProductLoadItem,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const { routeData } = usePageStore();
    const products = ref([]);
    const recentlyViewedSkus = ref<string[]>([]);
    const storageKey = "vsf-product-viewed";
    const maxStoredProducts = 8;
    const { fetchProducts, loading } = useSearchProducts();
    const uiHelpers = useUiHelpers();
    const fetchRecentlyViewedProducts = async () => {
      if (recentlyViewedSkus.value.length === 0) {
        return;
      }

      const params = {
        skus: recentlyViewedSkus.value,
        pageSize: maxStoredProducts || 12,
      };
      const { data } = await fetchProducts(params);

      const productsData = data || [];
      if (productsData) {
        const sortedProducts = [...productsData].sort((a, b) => {
          const aIndex = recentlyViewedSkus.value.indexOf(a.sku);
          const bIndex = recentlyViewedSkus.value.indexOf(b.sku);
          return aIndex - bIndex;
        });
        products.value = sortedProducts;
      }
    };
    const slickProductItemsOptions = {
      slidesPerView: 2.05,
      slidesPerGroup: 2,
      spaceBetween: 4,
      centeredSlides: false,
      loop: false,
      pagination: { clickable: true },
      scrollbar: {draggable: true },
      navigation: true,
      freeMode: true,
      breakpoints: {
        640: {
          slidesPerView: 2.05,
          slidesPerGroup: 2,
          spaceBetween: 4,
        },
        768: {
          slidesPerView: 3.2,
          slidesPerGroup: 3,
          spaceBetween: 4,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
        1440: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
      },
    };

    const updateRecentlyViewedProducts = () => {
      if (!routeData.sku || typeof localStorage === "undefined") {
        return;
      }

      try {
        let viewedSkus: string[] = [];
        try {
          viewedSkus = JSON.parse(localStorage.getItem(storageKey)) || [];
        } catch (e) {
          console.error("Failed to parse stored viewed products:", e);
        }

        const filteredSkus = viewedSkus.filter((sku) => sku !== routeData.sku);

        filteredSkus.unshift(routeData.sku);

        const limitedSkus = filteredSkus.slice(0, maxStoredProducts);

        localStorage.setItem(storageKey, JSON.stringify(limitedSkus));

        recentlyViewedSkus.value = limitedSkus.filter(
          (sku) => sku !== routeData.sku
        );
      } catch (e) {
        console.error("Failed to update recently viewed products:", e);
      }
    };

    onMounted(() => {
      updateRecentlyViewedProducts();

      if (
        typeof localStorage !== "undefined" &&
        localStorage.getItem(storageKey)
      ) {
        try {
          const allSkus = JSON.parse(localStorage.getItem(storageKey)) || [];
          recentlyViewedSkus.value = allSkus.filter(
            (sku) => sku !== routeData.sku
          );
          fetchRecentlyViewedProducts();
        } catch (e) {
          console.error("Failed to parse stored viewed products:", e);
        }
      }
    });

    return {
      products,
      loading,
      slickProductItemsOptions,
      modules: [Navigation, Scrollbar],
    };
  },
});
